import { Actions, thunk } from 'easy-peasy';
import { IStoreModel } from '~/store/types';
import api from '~/services/api';
import { IClientAllocationDetailed } from '~/services/api/clientAllocation/types';
import AllocationTypes from '~/ui/pages/ActTeam/reusable/ClientAllocationForm/constants/allocationTypes';
import { IClientAllocationActions, IThunkGetOwnClientAllocation } from '../types';

const onGetOwnClientAllocationGU: IThunkGetOwnClientAllocation = thunk(
  async (
    { setClientAllocation }: Actions<IClientAllocationActions>,
    payload,
    { getStoreState },
  ) => {
    const store = getStoreState() as IStoreModel;

    const profile = store.user.current;

    const allocations = await api.clientAllocation
      .getOwnClientAllocationGU({
        clientAllocationDate: payload.clientAllocationDate,
        allocationType: AllocationTypes.ALL,
      })
      .then(r => r.data);

    if (!allocations.length) {
      return;
    }

    const normalizedAllocations = allocations.map(allocation => ({
      id: allocation.id,
      date: allocation.date,
      isArchived: false,
      isOwn: true,
      locationGroups: allocation.locationGroups,
      team: allocation.team,
      isCrisis: allocation.isCrisis,
      resolved: allocation.resolved,
      user: {
        id: profile.id,
        name: `${profile.firstName} ${profile.lastName}`,
        subRoles: profile.subRoles,
        photo: profile.photo,
        clients: allocation.clients,
      },
    }));

    // normalizedAllocations nest clients under `user` and omit top-level `clients`,
    // unlike IClientAllocationDetailed's shape
    setClientAllocation(normalizedAllocations as unknown as IClientAllocationDetailed[]);
  },
);

export default onGetOwnClientAllocationGU;
